import { Link } from 'gatsby';
import { SingleImage, MultiImage, MultiImageContainer } from "../../../../src/components/portfolio-page";
import * as React from 'react';
export default {
  Link,
  SingleImage,
  MultiImage,
  MultiImageContainer,
  React
};